/*
  +--------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     通知数据管理
  +--------------------------------------------------------------------------------------
*/

import { getMessageEventApi } from '@/api/fnc/fncMessageApi'

const fncStore = {
  state: {
    unreadMessageNum: 0
  },
  mutations: {
    SET_UNREAD_MESSAGE_NUM: (state, num) => {
      state.unreadMessageNum = num
    },
    RESET_FNC: (state) => {
      state.unreadMessageNum = 0
    }
  },
  actions: {
    // 获取未读消息数量
    getUnreadMessageNum({ commit }) {
      return new Promise((resolve, reject) => {
        getMessageEventApi().then(response => {
          if (!response.errno) {
            commit('SET_UNREAD_MESSAGE_NUM', response.data.total)
          }
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}

export default fncStore
